import { render, staticRenderFns } from "./DataApiIcon.vue?vue&type=template&id=45cf2853&scoped=true"
import script from "./DataApiIcon.vue?vue&type=script&lang=js"
export * from "./DataApiIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cf2853",
  null
  
)

export default component.exports